<template>
  <div>
    <!-- ユーザー検索 -->
    <UserSearch class="section" :lang="lang" :lang-path="langPath"></UserSearch>
    <!-- 検索条件エリア -->
    <!-- ①項目が可変 -->
    <RefinedSearch
      class="section"
      :is-loading-ranking="isLoadingRanking"
      :is-not-found="isNotFound"
      :is-server-error="isServerError"
      :is-company="true"
      :data-ranking="dataRanking"
      :data-event-summary="dataEventSummary"
      @type-narrowing-down="typeNarrowingDown"
      @initial-ranking="initialRanking"
    ></RefinedSearch>
    <!-- ランキング -->
    <section class="section">
      <!-- ページング  -->
      <v-pagination
        v-if="!isLoadingRanking && !isNotFound && !isServerError"
        v-model="$page.current"
        v-bind:length="$page.total"
        v-bind:total-visible="$page.visible"
        color="#0093e6"
        class="rank-pagination"
      ></v-pagination>
      <Status
        :is-loading-ranking="isLoadingRanking"
        :is-not-found="isNotFound"
        :is-server-error="isServerError"
        :is-initial-ranking-data="isInitialRankingData"
        :event-status="eventStatus"
        :count-total-runner="countTotalRunner"
        @initial-ranking="initialRanking"
      ></Status>
      <!-- ランキングリスト（1位~100位） -->
      <!-- ①項目が可変 -->
      <RankingList
        v-if="!isLoadingRanking && !isNotFound && !isServerError"
        :lang="lang"
        :lang-path="langPath"
        :ranking="Ranking"
        :data-event-ranking="dataEventRanking"
        :data-event-summary="dataEventSummary"
        :data-ranking="dataRanking"
        :event-status="eventStatus"
        :is-foreign-country="isForeignCountry"
        :is-company="true"
        :nass-event-id="nassEventId"
      ></RankingList>
      <!-- ページング  -->
      <v-pagination
        v-if="!isLoadingRanking && !isNotFound && !isServerError"
        v-model="$page.current"
        v-bind:length="$page.total"
        v-bind:total-visible="$page.visible"
        color="#0093e6"
        class="rank-pagination"
      ></v-pagination>
    </section>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import Ranking from "../../../../assets/constants/ranking/ranking.json";
import Loading from "../../Loading";
import BadRequest from "../../../common/status/BadRequest";
import InternalServerError from "../../../common/status/InternalServerError";
import UserSearch from "../../ranking/UserSearch";
import RefinedSearch from "../../ranking/RefinedSearch";
import Status from "../../ranking/Status";
import RankingList from "../../ranking/RankingList";

export default {
  props: {
    dataEventRanking: Object,
    dataEventSummary: Object,
    isForeignCountry: Boolean,
  },
  data() {
    return {
      isLoadingRanking: true,
      isBadRequest: false,
      isNotFound: false,
      isServerError: false,
      isInitialRankingData: false,
      selectGender: "",
      selectAge: "",
      selectCountry: "",
      selectBranch: "",
      selectDepartment: "",
      selectAffiliation: "",
      dataRanking: null,
      nassEventId: "",
      eventStatus: "",
      countTotalRunner: 0,
    };
  },
  async created() {
    // イベントID取得
    this.nassEventId = sessionStorage.getItem("nassEventId");
    // ランキング取得
    await this.initialRanking();
  },
  methods: {
    /**
     * 初回検索
     */
    initialRanking: async function () {
      // 絞り込み初期化
      this.selectGender = "";
      this.selectAge = "";
      this.selectCountry = "";
      this.selectBranch = "";
      this.selectDepartment = "";
      this.selectAffiliation = "";

      // 条件初期化
      this.initialConditions();

      // 通信
      await this.fetchRanking(false);

      // 「〇〇人見つかりました」はinitialの時は表示しない
      this.isInitialRankingData = false;
    },

    /**
     * ランキング絞り込み検索
     */
    typeNarrowingDown: async function (
      selectGender,
      selectAge,
      selectArea,
      selectCountry,
      selectBranch,
      selectDepartment,
      selectAffiliation
    ) {
      // 条件初期化
      this.selectGender = selectGender;
      this.selectAge = selectAge;
      this.selectCountry = selectCountry;
      this.selectBranch = selectBranch;
      this.selectDepartment = selectDepartment;
      this.selectAffiliation = selectAffiliation;
      await this.initialConditions();
      await this.fetchRanking(true);
    },

    /**
     * コンポーネントの状態とデータの初期化
     */
    initialConditions: function () {
      this.isLoadingRanking = true;
      this.isNotFound = false;
      this.isServerError = false;
      this.dataRanking = null;
      this.countTotalRunner = 0;
    },

    /**
     * 通信部分共通
     */
    fetchRanking: async function (isOffsetInitial) {
      // 年齢分ける
      const list = this.selectAge ? this.selectAge.split(",") : [];
      const param = {
        nass_event: this.nassEventId,
        gender: this.selectGender,
        min_age: list[0] || "",
        max_age: list[1] || "",
        country: this.selectCountry,
        branch: this.selectBranch,
        department: this.selectDepartment,
        affiliation: this.selectAffiliation,
        offset: isOffsetInitial ? 0 : (this.$route.query.page - 1) * 100,
        limit: 100,
        size: 100,
        lang: this.lang,
      };

      try {
        const RankingRepository = RepositoryFactory.get("ranking");
        const response = await RankingRepository.getRanking(param);
        this.dataRanking = response.data;

        // 総件数（paging用と表示用）
        this.$page.rows = response.data.metadata.total_count;
        this.countTotalRunner = response.data.metadata.total_count;

        // イベントステータス（'0'か'100'）
        this.eventStatus = response.data.metadata.status;

        // 「〇〇人見つかりました」はinitialの時は表示しない
        this.isInitialRankingData = true;

        // ページ数をセット
        this.$page.current = isOffsetInitial ? 1 : this.$route.query.page;
      } catch (e) {
        if (e.response.status === 404) {
          this.$page.rows = 0;
          this.isNotFound = true;
        } else {
          this.isServerError = true;
        }
      } finally {
        this.isLoadingRanking = false;
      }
    },
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  watch: {
    "$page.current": function (newNumber) {
      this.$router.push(
        {
          name: this.name,
          query: {
            event: this.$route.query.event,
            page: newNumber,
          },
        },
        () => {
          this.fetchRanking(false);
        }
      );
    },
  },
  components: {
    Loading,
    BadRequest,
    InternalServerError,
    UserSearch,
    RefinedSearch,
    Status,
    RankingList,
  },
  name: "CloseRankingContents",
};
</script>

<style scoped>
.section {
  margin: 60px 0 0 0;
}

.rank-pagination {
  margin: 80px 0 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/company/ranking/CloseRankingContents.vue